import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { RequestsTable } from 'modules/salary_advance/pages/RequestPage/RequestsTable/RequestsTable'

const RequestsPage = () => {
  return (
    <ResponsivePage.Body variant="full">
      <RequestsTable />
    </ResponsivePage.Body>
  )
}

export default RequestsPage
